<div class="snackbar">
  <span class="material-symbols-outlined" [ngStyle]="{ color: '#FAFAFA' }">
    check_circle
  </span>
  <sl-typography
    variant="body-20"
    [text]="text"
    color="var(--color-neutral-10)"
  ></sl-typography>
  <sl-link
    variant="button"
    [text]="actionText"
    (actionEvent)="clickLinkEvent()"
  ></sl-link>
</div>
